import * as Actions from "./actions";

const initialState = {
  game: {
    isLoading: false,
    isStarted: false,
    owner: false,
    data: "[]",
    token: "",
  },
  games: {
    isLoading: false,
    data: [],
  },
};

const games = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GAME.REQUEST:
      return { ...state, game: { isLoading: true, isStarted: false, owner: false } };
    case Actions.GAME.SUCCESS:
      return { ...state, game: { data: action.payload.data, isLoading: false, errors: null, isStarted: true, owner: false } };
    case Actions.GAME.FAILURE:
      return { ...state, game: { errors: action.payload.data, isLoading: false, isStarted: false, owner: false } };
    case Actions.GAME.INITIAL:
      return { ...state, game: initialState.game };

    case Actions.GAMES.REQUEST:
      return { ...state, games: { isLoading: true } };
    case Actions.GAMES.SUCCESS:
      return { ...state, games: { data: action.payload.data, isLoading: false, errors: null } };
    case Actions.GAMES.FAILURE:
      return { ...state, games: { errors: action.payload.data, isLoading: false } };

    case Actions.PREPARE_GAME.REQUEST:
      return { ...state, game: { isLoading: true, isStarted: false, owner: true } };
    case Actions.PREPARE_GAME.SUCCESS:
      return { ...state, game: { isLoading: false, isStarted: true, owner: true, data: action.payload.data, token: action.payload.token } };
    case Actions.PREPARE_GAME.FAILURE:
      return { ...state, game: { isLoading: false, isStarted: false, owner: false } };

    default:
      return state;
  }
};

export default games;
